import Number from '../../core/utils/Number'

export default class OnlineNumberUpdater {
   constructor({selector}) {
      document.querySelectorAll(selector).forEach(item => {
         setInterval(() => {
            const currentValue = parseInt(item.textContent)
            const toAdd = Number.getRandomInt(0, 8)
            item.textContent = (
               Number.getRandomInt(0, 10) > 3 || ((currentValue - toAdd) < 0)
                  ? currentValue + toAdd
                  : currentValue - toAdd
            ).toString()
         }, Number.getRandomInt(11, 30) * 100)
      })
   }
}
